import { useInfiniteQuery } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';
import { IGetInboundHistoryListPayload } from '../../../types';

import { formatInboundHistoryListResponse } from '../transformers';

/**
 * This is to track the Inbound history list from the backend.
 */
export const INBOUND_HISTORY_LIST_KEY = 'inbound-history-list-query';

interface IInboundHistoryListQuery {
  payload: IGetInboundHistoryListPayload;
}

/**
 * This hook fetches the inbound history list.
 */
export const useInboundHistoryListQuery = ({
  payload,
}: IInboundHistoryListQuery) => {
  const { enabled, limit, inventoryTransactionId, historyType } = payload;
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isPending,
    refetch,
  } = useInfiniteQuery({
    enabled,
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      INBOUND_HISTORY_LIST_KEY,
      historyType,
      inventoryTransactionId,
      limit,
    ],
    networkMode: 'always',
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) =>
      INBOUND_API.fetchInboundHistoryList({ ...payload, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      const currentCount = allPages.length * limit;

      return currentCount < lastPage.total ? nextPage : undefined;
    },
    select: formatInboundHistoryListResponse,
  });

  return {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isPending,
    refetchInboundHistoryInfo: refetch,
  };
};
